import ProxyQuickResult from './ProxyQuickResult'
export default ProxyQuickResult
